export function unicodeToEmoji(unicodeStr: string): string {
  return unicodeStr
    .split(' ')
    .map(code => String.fromCodePoint(parseInt(code.replace('U+', ''), 16)))
    .join('')
}
